import { render, staticRenderFns } from "./DropdownSimple.vue?vue&type=template&id=b1a696a8&scoped=true&"
import script from "./DropdownSimple.vue?vue&type=script&lang=js&"
export * from "./DropdownSimple.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSimple.vue?vue&type=style&index=0&id=b1a696a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a696a8",
  null
  
)

export default component.exports